import { gql, useQuery, QueryHookOptions } from '@apollo/client';
import { GAME_TYPES_TYPE } from '../../../../constants/constants';

export const query = gql`
  query PlayFriendGamesByUserHiveAndGameType($userId: String!, $gameType: GameType) {
    playFriendGamesByUserHiveAndGameType(userId: $userId, gameType: $gameType) {
      _id
      userId
      gameType
      opponentName
      played
      won
      createdAt
      updatedAt
    }
  }
`;

export interface GymPlayFriendGameType {
  _id: string;
  userId: string;
  gameType: GAME_TYPES_TYPE;
  opponentName: string;
  played: number;
  won: number;
  createdAt: string;
  updatedAt: string;
}

export interface RequestType {
  userId: string;
  gameType: GAME_TYPES_TYPE;
}

export interface QueryType {
  playFriendGamesByUserHiveAndGameType: GymPlayFriendGameType[];
}

export function usePlayFriendGamesQuery(
  request: RequestType,
  options?: QueryHookOptions<QueryType, RequestType>,
) {
  return useQuery<QueryType, RequestType>(query, {
    variables: request,
    ...options,
  });
}
